import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { STORE_ADMINISTRATION_HISTORY } from '../stores/constants';
import { HistoryStores } from '../stores';
import { HasPermission } from '../../authorization/components/HasPermission';
import { AppPermissions } from '../../authorization/Permissions';
import { AdministrationHistoryGrid } from '../components';

const AdministrationHistoryPage: React.FC<HistoryStores> = ({ administrationHistory: store }) => {
    if (!store) {
        return null;
    }

    return (
        <HasPermission
            permissionClaim={AppPermissions.CanAccessAdministration}
            yes={() => <AdministrationHistoryGrid store={store} />}
        />
    );
};

export default inject(STORE_ADMINISTRATION_HISTORY)(observer(AdministrationHistoryPage));
